import React from 'react';
import { Link } from 'react-router-dom';
import PlaceAutocomplete from '../PlaceAutocomplete';
import useAddressStore from '../../state/useAddressStore';

const HeroSection = () => {
  const address = useAddressStore((s) => s.address);
  const setAddress = useAddressStore((s) => s.setAddress);

  return (
    <div className="flex flex-col items-center py-[50px]">
      <div className='flex flex-col px-[20px] md:px-[40px] max-w-[1000px]'>
        <div className="w-full space-y-[24px] md:space-y-[32px] text-center">
          <div>
            <h1 className="text-[32px] md:text-[64px] font-extrabold text-[#1B1A1A] leading-[40px] md:leading-[75px] font-cabinet">
              Sell Your House <span className="text-[#FFBD00]">As Is </span><br/>
              Fast, <span className="text-[#FFBD00]">Easy</span>, and Fair!
            </h1>
          </div>
          <div className="space-y-[12px] md:space-y-[16px] flex flex-col items-center">
            <div className="flex space-x-[10px] justify-center">
              <p className="font-satoshi text-[#5A5A5A] text-[18px] md:text-[18px] font-bold ">
                At Moreproperties, we believe the house selling process should be faster, <br/>
                easier, and hassle-free for Minnesota home sellers. Get Your Offer Today!
              </p>
            </div>
          </div>
          
          <div className="flex justify-center">
            <div className="w-full max-w-[560px]">
              <PlaceAutocomplete value={address} onChange={setAddress} placeholder="Enter the property address" name="hero-address" />
            </div>
          </div>

          <div className="flex justify-center">
            {address && address.trim() ? (
              <Link to="get-offer" state={{ address }}>
                <button className="text-white font-satoshi bg-[#03002F] py-[12px] md:py-[19px] px-[16px] md:px-[34px] rounded-[8px] flex items-center hover:bg-[#050041] transition-colors">
                  Sell Property
                </button>
              </Link>
            ) : (
              <button disabled aria-disabled="true" title="Enter an address to continue" className="text-white font-satoshi bg-[#03002F] py-[12px] md:py-[19px] px-[16px] md:px-[34px] rounded-[8px] flex items-center opacity-50 cursor-not-allowed">
                Sell Property
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="w-full"></div>
    </div>
  );
}

export default HeroSection;